module.exports = __webpack_public_path__ + "static/media/287ea8be-8543-49f5-9883-58e9bc78ca2e.fdc8bab4.jpg";